import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { keysToTranslate } from 'i18n/keys-to-translate';
import {
  BauprojektListEntry,
  BauprojektSearchResponse,
  BauprojektStandardRequest,
  GwrbauprojektService,
  GwrGebaeudeListEntry,
  GwrgebaeudeService,
  GwrGebaeudeStandardRequest
} from 'app/core/gwr-api';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { ListLoaderPreloaded } from '../../shared/components/list-loader/list-loader-preloaded';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../../core/extension/exceptions/cap-alert-level.enum';
import { GwrStatus } from '../../shared/enum/GwrStatus';
import { CapAlertListComponent } from '../../core/extension/exceptions/cap-alert-list.component';
import { RubrikComponent } from '../../shared/components/rubrik/rubrik.component';
import { GwrGebaeudeTableComponent } from '../../gwr/gwr-gebaeude/gwr-gebaeude-table/gwr-gebaeude-table.component';
import { GwrBauprojektTableComponent } from '../../gwr/gwr-bauprojekt/gwr-bauprojekt-table/gwr-bauprojekt-table.component';

@Component({
  selector: 'cap-grundstueck-gwr-objekte',
  templateUrl: './grundstueck-gwr-objekte.component.html',
  styleUrls: ['./grundstueck-gwr-objekte.component.scss'],
  imports: [CapAlertListComponent, RubrikComponent, GwrGebaeudeTableComponent, GwrBauprojektTableComponent, TranslatePipe]
})
export class GrundstueckGwrObjekteComponent extends AbstractComponent implements OnInit {
  alertLevelContentHeader: CapAlertLevel.CONTENT_HEADER;
  listLoaderGebaeude: ListLoader<GwrGebaeudeListEntry>;
  listLoaderBauprojekte: ListLoader<BauprojektListEntry>;

  constructor(
    private gwrGebaeudeService: GwrgebaeudeService,
    private gwrBauprojektService: GwrbauprojektService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private capAlertService: CapAlertService
  ) {
    super();
    keysToTranslate(['GWRBauprojekte', 'GWRGebaeude']);
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((q) => {
      const gebaeudeRequest: GwrGebaeudeStandardRequest = {
        gemeindeEntry: {
          bfsNummer: +q.get('bfsnummer')
        },
        grundstueckNummer: q.get('grundstuecknummer'),
        egrid: { value: q.get('egrid') }
      };
      this.loadGwrGebaeude(gebaeudeRequest);

      const bauprojektRequest: BauprojektStandardRequest = {
        bauortEntry: {
          nummer: +q.get('bfsnummer')
        },
        grundstueckNummer: q.get('grundstuecknummer')
      };
      this.loadGwrBauprojekt(bauprojektRequest);
    });
  }

  private loadGwrGebaeude(request: GwrGebaeudeStandardRequest) {
    this.addSub(
      this.gwrGebaeudeService.searchGebaeudeStandard(request).subscribe((response) => {
        const wsStatus = response.gwrStatusCode;
        if (wsStatus.statusCode === GwrStatus.NORESULTS) {
          // empty, no matching results
          this.listLoaderGebaeude = new ListLoaderPreloaded<GwrGebaeudeListEntry>(0, 0, []);
        } else if (wsStatus.statusCode !== GwrStatus.OK) {
          const alertText = this.translate.instant('FehlerBeimAufrufDesWebservice');
          this.capAlertService.warning(`${alertText}: ${wsStatus.statusCode} (${wsStatus.text})`, CapAlertLevel.CONTENT_HEADER, false);
          this.listLoaderGebaeude = new ListLoaderPreloaded<GwrGebaeudeListEntry>(0, 0, []);
        } else {
          this.fillGebaeudeListFrom(response);
        }
      })
    );
  }

  private loadGwrBauprojekt(request: BauprojektStandardRequest) {
    this.addSub(
      this.gwrBauprojektService.searchBauprojektStandard(request).subscribe((response) => {
        const wsStatus = response.gwrStatusCode;
        if (wsStatus.statusCode === GwrStatus.NORESULTS) {
          // empty, no matching results
          this.listLoaderBauprojekte = new ListLoaderPreloaded<BauprojektListEntry>(0, 0, []);
        } else if (wsStatus.statusCode !== GwrStatus.OK) {
          const alertText = this.translate.instant('FehlerBeimAufrufDesWebservice');
          this.capAlertService.warning(`${alertText}: ${wsStatus.statusCode} (${wsStatus.text})`, CapAlertLevel.CONTENT_HEADER, false);
          this.listLoaderBauprojekte = new ListLoaderPreloaded<BauprojektListEntry>(0, 0, []);
        } else {
          this.fillBauprojektListFrom(response);
        }
      })
    );
  }

  private fillGebaeudeListFrom(response) {
    this.listLoaderGebaeude = new ListLoaderPreloaded<GwrGebaeudeListEntry>(15, 1, response.results);
  }

  private fillBauprojektListFrom(response: BauprojektSearchResponse) {
    this.listLoaderBauprojekte = new ListLoaderPreloaded<BauprojektListEntry>(15, 1, response.results);
  }
}
